import React, {RefObject} from 'react';

import classNames from 'classnames';

import {Button, IButtonProps} from '../../components/button';
import {Check, ICheckProps} from '../../components/forms/check';
import {Grid, GridColumn} from '../../components/grid';
import {ITextFieldProps, TextField} from '../../components/forms/textfield';
import { Capacitor } from '@capacitor/core';

export interface ILoginFormProps {
    button: IButtonProps;
    fields: ITextFieldProps[];
    title: string;
    check?: ICheckProps;
    recovery?: ILoginFormRecoveryProps;
    className?: string;
    elementRef?: RefObject<HTMLFormElement>;
    onSubmit?: () => void;
}

export interface ILoginFormRecoveryProps {
    label: string;
    link: JSX.Element;
}

const LoginForm = (props: ILoginFormProps): JSX.Element => {
    const className: string = classNames(
        'login-form',
        props.className,
    );

    const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
        if (props.onSubmit) {
            props.onSubmit();
        }
    };

    return (
        <form className={className} onSubmit={onSubmit} ref={props.elementRef}>
            <div className="text text-center text--triple">
                <h1 className="h2">{props.title}</h1>
                <div className="text">
                    {props.fields.map((el: ITextFieldProps, i: number) => <TextField {...el} key={i} isStatic={true} iconSize="small" />)}
                    {props.check && <Check {...props.check} />}
                    <Button {...props.button} block={true} />
                    {props.recovery &&
                        <Grid justify={['between-xs']}>
                            <GridColumn className="text-left" width={['max-xs']}>
                                {props.recovery.label}
                            </GridColumn>
                            <GridColumn width={['min-xs']}>
                                {props.recovery.link}
                            </GridColumn>
                        </Grid>
                    }
                    <button type='submit' style={{display: 'none'}}/>
                </div>
                <div style={Capacitor.getPlatform() === 'web' ? {display: 'none'} : {}}>
                    <a href="/privacypolicy">
                    Privacy policy
                    </a>
                </div>
            </div>
        </form>
    );
};

export default LoginForm;
